import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { convertToVwWeb } from '../../Utils/responsive';
import { useNavigate } from 'react-router-dom';

interface ProfileIncompleteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProfileIncompleteModal: React.FC<ProfileIncompleteModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleConfirm = () => {
    onClose();
    navigate('/account');
  };

  return (
    <ModalOverlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalTitle>정보 입력이 필요해요</ModalTitle>
        <ModalDesc>
          <p>나의 계정 정보 입력 후</p>
          <p>모금 프로젝트를 생성할 수 있습니다.</p>
        </ModalDesc>
        <ConfirmButton onClick={handleConfirm}>
          나의 계정으로 이동
        </ConfirmButton>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ProfileIncompleteModal;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background-color: white;
  width: ${convertToVwWeb(400)};
  padding: ${convertToVwWeb(30)} ${convertToVwWeb(20)} ${convertToVwWeb(20)};
  border-radius: ${convertToVwWeb(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${convertToVwWeb(20)};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    width: 300px;
    padding: 30px 20px 20px;
    border-radius: 16px;
    gap: 20px;
  }
`;

const ModalTitle = styled.h2`
  color: #17171B;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 30px */
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const ModalDesc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  
  p {
    color: #17171B;
    text-align: center;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    margin: 0;
  }

  @media (max-width: 768px) {
    p {
      font-size: 14px;
    }
  }
`;

const ConfirmButton = styled.button`
  width: 100%;
  height: ${convertToVwWeb(56)};
  background-color: #026478; 
  border-radius: ${convertToVwWeb(12)};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  color: #FFF;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  
  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    height: 48px;
    border-radius: 12px;
    font-size: 16px;
  }
`;
